import {
  CREATE_ADELE_TEST_START,
  CREATE_ADELE_TEST_SUCCESS,
  CREATE_ADELE_TEST_ERROR,
  START_ADELE_TEST_START,
  START_ADELE_TEST_SUCCESS,
  START_ADELE_TEST_ERROR,
  UPDATE_TEST_RESULTS,
  LEI_TEST_START,
  LEI_TEST_SUCCESS,
  LEI_TEST_ERROR,
  LIS_TEST_START,
  LIS_TEST_SUCCESS,
  LIS_TEST_ERROR,
  RAD_TEST_START,
  RAD_TEST_SUCCESS,
  RAD_TEST_ERROR,
  HERMES_TEST_START,
  HERMES_TEST_SUCCESS,
  HERMES_TEST_ERROR,
  PSAP_DASHBOARD_TEST_START,
  PSAP_DASHBOARD_SUCCESS,
  PSAP_DASHBOARD_ERROR,
  TEST_FINISHED,
  RESET,
  FETCH_OAUTH_START,
  FETCH_OAUTH_SUCCESS,
  FETCH_OAUTH_ERROR,
  RESET_RESULTS,
} from '../actions/actionTypes';

const initialState = {
  adeleTestStarting: false,
  adeleResults: null,
  adeleError: null,
  leiTestStarting: false,
  leiResults: null,
  leiError: null,
  lisTestStarting: false,
  lisResults: null,
  lisError: null,
  radTestStarting: false,
  radResults: null,
  radError: null,
  hermesTestStarting: false,
  hermesResults: null,
  hermesError: null,
  adeleTestData: null,
  psapTestStarting: false,
  psapResults: null,
  psapError: null,
  creatingAdeleTest: false,
  testsFinished: false,
  testResults: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OAUTH_START:
      return {
        ...state,
        fetchingData: true,
        error: null,
      };
    case FETCH_OAUTH_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        error: null,
        data: action.payload,
      };
    case FETCH_OAUTH_ERROR:
      return {
        ...state,
        fetchingData: false,
        error: action.payload,
        data: null,
      };
    case CREATE_ADELE_TEST_START:
      return {
        ...state,
        creatingAdeleTest: true,
        adeleCreateTestError: null,
      };
    case CREATE_ADELE_TEST_SUCCESS:
      return {
        ...state,
        creatingAdeleTest: false,
        adeleTestData: action.payload,
        adeleCreateTestError: null,
      };
    case CREATE_ADELE_TEST_ERROR:
      return {
        ...state,
        creatingAdeleTest: false,
        results: null,
        adeleCreateTestError: action.payload,
        adeleTestData: null,
      };
    case START_ADELE_TEST_START:
      return {
        ...state,
        adeleTestStarting: true,
        adeleError: null,
        adeleResults: null,
      };
    case START_ADELE_TEST_SUCCESS:
      return {
        ...state,
        adeleTestStarting: false,
        adeleError: null,
        adeleResults: action.payload,
      };
    case START_ADELE_TEST_ERROR:
      return {
        ...state,
        adeleTestStarting: false,
        adeleError: true,
        adeleResults: action.payload,
      };
    case UPDATE_TEST_RESULTS:
      return {
        ...state,
        testResults: [...state.testResults, action.payload],
      };
    case RESET_RESULTS:
      return {
        ...state,
        testResults: [],
      };
    case LEI_TEST_START:
      return {
        ...state,
        leiTestStarting: true,
        leiError: null,
        leiResults: null,
      };
    case LEI_TEST_SUCCESS:
      return {
        ...state,
        leiTestStarting: false,
        leiError: null,
        leiResults: action.payload,
      };
    case LEI_TEST_ERROR:
      return {
        ...state,
        leiTestStarting: false,
        leiError: action.payload,
        leiResults: null,
      };
    case LIS_TEST_START:
      return {
        ...state,
        lisTestStarting: true,
        lisError: null,
        lisResults: null,
      };
    case LIS_TEST_SUCCESS:
      return {
        ...state,
        lisTestStarting: false,
        lisError: null,
        lisResults: action.payload,
      };
    case LIS_TEST_ERROR:
      return {
        ...state,
        lisTestStarting: false,
        lisError: action.payload,
        lisResults: null,
      };
    case RAD_TEST_START:
      return {
        ...state,
        radTestStarting: true,
        radError: null,
        radResults: null,
      };
    case RAD_TEST_SUCCESS:
      return {
        ...state,
        radTestStarting: false,
        radError: null,
        radResults: action.payload,
      };
    case RAD_TEST_ERROR:
      return {
        ...state,
        radTestStarting: false,
        radError: action.payload,
        radResults: null,
      };
    case HERMES_TEST_START:
      return {
        ...state,
        hermesTestStarting: true,
        hermesError: null,
        hermesResults: null,
      };
    case HERMES_TEST_SUCCESS:
      return {
        ...state,
        hermesTestStarting: false,
        hermesError: null,
        hermesResults: action.payload,
      };
    case HERMES_TEST_ERROR:
      return {
        ...state,
        hermesTestStarting: false,
        hermesError: action.payload,
        hermesResults: null,
      };
    case PSAP_DASHBOARD_TEST_START:
      return {
        ...state,
        psapTestStarting: true,
        psapError: action.payload,
        psapResults: null,
      };
    case PSAP_DASHBOARD_SUCCESS:
      return {
        ...state,
        psapTestStarting: false,
        psapError: null,
        psapResults: action.payload,
      };
    case PSAP_DASHBOARD_ERROR:
      return {
        ...state,
        psapTestStarting: false,
        psapError: action.payload,
        psapResults: null,
      };
    case TEST_FINISHED:
      return {
        ...state,
        testsFinished: action.payload,
      };
    case RESET:
      return {
        adeleTestStarting: false,
        adeleResults: null,
        adeleError: null,
        leiTestStarting: false,
        leiResults: null,
        leiError: null,
        lisTestStarting: false,
        lisResults: null,
        lisError: null,
        radTestStarting: false,
        radResults: null,
        radError: null,
        hermesTestStarting: false,
        hermesResults: null,
        hermesError: null,
        adeleCreateResults: null,
        psapTestStarting: false,
        psapResults: null,
        psapError: null,
        creatingAdeleTest: false,
        testsFinished: false,
      };
    default:
      return state;
  }
};
